module.exports = __webpack_public_path__ + "img/filter.23557ff1.svg";